<template>
  <div>
    <div class="table-wrapper">
      <table>
        <thead>
          <tr>
            <th>
              <p><strong>参数名</strong></p>
            </th>
            <th>
              <p><strong>值</strong></p>
            </th>
            <th>
              <p><strong>规则说明</strong></p>
            </th>
            <th>
              <p><strong>是否必填</strong></p>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <p>address</p>
            </td>
            <td>
              <el-input v-model="params.address"
                        size="small"
                        placeholder="地址信息" />
            </td>
            <td>
              <p>
                地址信息
              </p>
            </td>
            <td>
              <p>是</p>
            </td>
          </tr>
          <tr>
            <td>
              <p>city</p>
            </td>
            <td>
              <el-input v-model="params.city"
                        size="small"
                        placeholder="查询城市" />
            </td>
            <td>
              <p>查询城市</p>
            </td>
            <td>
              <p>否</p>
            </td>
          </tr>
          <template v-if="parameter">
            <tr>
              <td>
                <p>model</p>
              </td>
              <td>
                <el-input v-model="params.model"
                          size="small"
                          placeholder="返回结果的表达形式" />
              </td>
              <td>
                <p>
                  返回结果的表达形式
                </p>
              </td>
              <td>
                <p>否</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>stander</p>
              </td>
              <td>
                <el-input v-model="params.stander"
                          size="small"
                          placeholder="返回结果是否标准化" />
              </td>
              <td>
                <p>
                  返回结果是否标准化
                </p>
              </td>
              <td>
                <p>否</p>
              </td>
            </tr>
          </template>
          <template v-if="removeDuplication">
            <tr>
              <td>
                <p>remove_duplication</p>
              </td>
              <td>
                <el-input v-model="params.remove_duplication"
                          size="small"
                          placeholder="是否对原始地址去重" />
              </td>
              <td>
                <p>
                  是否对原始地址去重
                </p>
              </td>
              <td>
                <p>否</p>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <div style="margin-top: 12px">
      <button class="black-btn"
              @click="run">运行</button>
    </div>
    <div v-if="res"
         class="result-container">
      <div class="header">
        <div class="button-container"
             v-if="depth === 1"
             style="margin-right:18px"
             @click="expand">
          <img src="../assets/icon-expand.svg"
               alt="">
          <el-button type="text"
                     size="small">全部展开</el-button>
        </div>
        <div class="button-container"
             v-if="depth === 5"
             style="margin-right:18px"
             @click="collapse">
          <img src="../assets/icon-collapse.svg"
               alt="">
          <el-button type="text"
                     size="small">全部折叠</el-button>
        </div>
        <div class="button-container"
             @click="res = null">
          <img src="../assets/icon-close.svg"
               alt="">
          <el-button type="text"
                     size="small">关闭</el-button>
        </div>
      </div>
      <div class="url">{{ showUrl }}</div>
      <div>
        <vue-json-pretty v-if="res"
                         :data="res"
                         class="json-container"
                         :deep="depth"> </vue-json-pretty>
      </div>
    </div>
  </div>
</template>
<script>
import VueJsonPretty from 'vue-json-pretty'
import 'vue-json-pretty/lib/styles.css'

export default {
  components: {
    VueJsonPretty
  },
  props: {
    removeDuplication: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    parameter: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  data() {
    return {
      params: {
        key: 'lbs-meituan-demo',
        address: '',
        city: '',
        model: '',
        stander: '',
        remove_duplication: ''
      },
      baseUrl: !this.removeDuplication ? 'https://lbsapi.meituan.com/v1/format' : 'https://lbsapi.meituan.com/v2/format',
      url: '',
      res: null,
      showUrl: '',
      expanded: true,
      depth: 1
    }
  },
  methods: {
    run() {
      //
      const baseUrl = this.baseUrl
      const params = this.params
      this.url = `${baseUrl}?${this.$qs.stringify(params)}`
      this.$http.get(this.url).then((res) => {
        this.res = res.data
      })
      this.showUrl = this.url.replace('lbs-meituan-demo', '您的key')

      // //
    },
    expand() {
      const res = this.res
      this.depth = 5
      this.res = null
      this.$nextTick(() => {
        this.res = res
      })
    },
    collapse() {
      const res = this.res
      this.depth = 1
      this.res = null
      this.$nextTick(() => {
        this.res = res
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import '../document.less';
</style>
